import moment from "moment";
import React, { useState } from "react";
import { Col, Row } from "reactstrap";
import { fetchRawReport } from "services/services.summary";
import styled from "styled-components";
import { Toast } from "utility/helpers";
import CustomSelect from "components/customs/dropdown";
import { ALLOCATION_STATUS } from "constants/status";
import FormGenerator from "components/customs/form-generator/input";
import { HeaderText } from "assets/js/Styles";
import { generateReport } from "./utility";
import { exportOptions } from "./constants";

const Container = styled.div`
  margin-top: 24px;
`;

const StyledDropdown = styled(CustomSelect)`
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: visible;

  svg {
    color: white;
  }

  .select {
    &__placeholder {
      color: ${({ theme }) => theme.colors.white};
    }

    &__control {
      border: none !important;
      box-shadow: none !important;
      background-color: ${({ theme }) => theme.colors.buttonFormBlue};
      height: 53px;
      width: 100%;
      border-radius: 6px;

      &:hover {
        border: none;
      }

      &--is-disabled {
        background-color: #6c757d !important;
      }
    }

    &__value-container {
      justify-content: center;
    }

    &__single-value {
      text-align: center;
      color: white;
    }

    &__menu {
      .select__option {
        color: black;
      }
    }

    &__separator {
      display: none;
    }

    &__indicator-separator {
      display: none;
    }
  }
`;

const RequestButton = styled(StyledDropdown)`
  .select {
    &__control {
      background-color: ${({ theme }) => theme.colors.buttonRed};
    }
  }
`;

const FormSection = styled.div`
  margin-top: 44px;
`;

const FormRow = styled(Row)`
  display: flex;
  margin: 0;
  justify-content: space-between;
  margin-top: 1rem;
`;

const FormLabel = styled.h5`
  font-weight: bold;
`;

const DateSection = styled.div`
  gap: 10px;
  display: flex;
  justify-content: space-between;

  .react-datepicker-wrapper {
    width: 100%;
  }
`;

const ButtonSection = styled(Col)`
  display: flex;
  justify-content: flex-end;
  gap: 44px;
`;

const HeaderSection = styled(Row)`
  display: flex;
  margin: 0;
  justify-content: space-between;
`;

const DailyReportTab = () => {
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const isBtnDisabled = !startDate;

  const handleExportBtnClicked = (type, option) => {
    setIsLoading(true);
    const formattedStartDate = moment(startDate).format("YYYY-MM-DD");
    const formattedEndDate = moment(endDate).format("YYYY-MM-DD");

    const status =
      type === "request"
        ? [ALLOCATION_STATUS.REQUESTED]
        : [ALLOCATION_STATUS.APPROVED];

    const params = {
      projectIds: "all",
      status: JSON.stringify(status),
      startDate: formattedStartDate,
      endDate:
        endDate && formattedStartDate !== formattedEndDate
          ? formattedEndDate
          : undefined,
      isDailyReport: true,
      receivingEntities: "all",
    };

    fetchRawReport({
      params,
      callback: ({ isSuccess, data }) => {
        setIsLoading(false);

        if (isSuccess && data.length !== 0) {
          const exportType = option?.value;
          generateReport(data, type, exportType, startDate, endDate);
        } else if (data.length === 0) {
          Toast({
            type: 4,
            content: "Empty data",
          });
        } else {
          Toast({
            type: 4,
            content: "An error occurred!",
          });
        }
      },
    });
  };

  return (
    <Container>
      <HeaderSection>
        <Col>
          <HeaderText>{"Daily Report"}</HeaderText>
        </Col>
        <ButtonSection>
          <RequestButton
            onChange={(option) => handleExportBtnClicked("request", option)}
            isDisabled={isBtnDisabled}
            isLoading={isLoading}
            options={exportOptions}
            placeholder="Request Report"
            value={[]}
          />

          <StyledDropdown
            onChange={(option) => handleExportBtnClicked("endorsement", option)}
            isDisabled={isBtnDisabled}
            isLoading={isLoading}
            options={exportOptions}
            placeholder="Endorsement Report"
            value={[]}
          />
        </ButtonSection>
      </HeaderSection>

      <FormSection>
        <FormRow>
          <Col
            xs="12"
            sm="6"
            md="6"
          >
            <FormLabel>{"Date"}</FormLabel>
            <p>{"Provide the date of implementation"}</p>
          </Col>
          <Col
            xs="12"
            sm="6"
            md="6"
          >
            <DateSection>
              <FormGenerator
                type="datetime"
                selected={startDate}
                placeholderText="Start Date"
                dateFormat="MMM-dd-yyyy"
                maxDate={new Date()}
                onChange={(date) => {
                  setStartDate(date);
                }}
              />

              <FormGenerator
                type="datetime"
                selected={endDate}
                placeholderText="End Date"
                dateFormat="MMM-dd-yyyy"
                maxDate={new Date()}
                onChange={(date) => {
                  setEndDate(date);
                }}
              />
            </DateSection>
          </Col>
        </FormRow>
      </FormSection>
    </Container>
  );
};

export default DailyReportTab;
